<h1 id="title" class="title color-brand">
    {{ "AUTH.TITLE-CHANGE-PASSWORD" | translate }}
</h1>
<p class="sub-title">{{ "AUTH.MESSAGE.TYPE-FORM" | translate }}</p>
<nb-alert *ngIf="alert.show" [status]="alert.type" role="alert">
    {{ alert.message }}
</nb-alert>
<form
    aria-labelledby="title"
    [formGroup]="form"
    #ngForm="ngForm"
    (ngSubmit)="requestPassword()"
>
    <div class="form-control-group" *ngIf="!changeFromEmail">
        <label class="label" for="input-email">{{
            "AUTH.ACTUAL-PASSWORD" | translate
        }}</label>
        <!-- prettier-ignore -->
        <input
            nbInput
            fullWidth
            name="currentPassword"
            id="input-currentPassword"
			placeholder="{{ 'AUTH.ACTUAL-PASSWORD' | translate }}"
			type="password"
            formControlName="currentPassword"
            [status]="controls.currentPassword.dirty ? (controls.currentPassword.invalid ? 'danger' : 'success') : ''"
        />
        <ng-container
            *ngIf="
                controls.currentPassword.invalid &&
                controls.currentPassword.touched
            "
        >
            <p class="error-message" *ngIf="controls.email.errors?.required">
                {{ "MESSAGE.FIELD.MANDATORY" | translate }}
            </p>
        </ng-container>
    </div>
    <div class="form-control-group">
        <label class="label" for="input-newPassword">{{
            "AUTH.NEW-PASSWORD" | translate
        }}</label>
        <!-- prettier-ignore -->
        <input
            nbInput
            fullWidth
            name="newPassword"
			id="input-newPassword"
			type="password"
            placeholder="{{ 'AUTH.NEW-PASSWORD' | translate }}"
            formControlName="newPassword"
            [status]="controls.newPassword.dirty ? (controls.newPassword.invalid ? 'danger' : 'success') : ''"
        />
        <ng-container
            *ngIf="controls.newPassword.invalid && controls.newPassword.touched"
        >
            <p
                class="error-message"
                *ngIf="controls.newPassword.errors?.required"
            >
                {{ "MESSAGE.FIELD.MANDATORY" | translate }}
            </p>
        </ng-container>
    </div>
    <div class="form-control-group">
        <label class="label" for="input-confirmNewPassword">{{
            "AUTH.CONFIRM-NEW-PASSWORD" | translate
        }}</label>
        <!-- prettier-ignore -->
        <input
            nbInput
            fullWidth
            name="confirmNewPassword"
			id="input-confirmNewPassword"
			type="password"
            placeholder="{{ 'AUTH.CONFIRM-NEW-PASSWORD' | translate }}"
            formControlName="confirmNewPassword"
            [status]="controls.confirmNewPassword.dirty ? (controls.confirmNewPassword.invalid ? 'danger' : 'success') : ''"
        />
        <ng-container
            *ngIf="
                controls.confirmNewPassword.invalid &&
                controls.confirmNewPassword.touched
            "
        >
            <p
                class="error-message"
                *ngIf="controls.confirmNewPassword.errors?.required"
            >
                {{ "MESSAGE.FIELD.MANDATORY" | translate }}
            </p>
        </ng-container>
    </div>
    <button
        nbButton
        fullWidth
        status="success"
        [disabled]="!ngForm.valid"
        [class.btn-pulse]="ngForm.submitted"
    >
        {{ "GENERAL.SEND" | translate }}
    </button>
</form>
